import React from 'react'
import moment from 'moment'
import globe from './images/facebook/facebook_globe.svg'
import menu from './images/facebook/facebook_menu.svg'
import like from './images/facebook/facebook_like.svg'
import comment from './images/facebook/facebook_comment.svg'
import share from './images/facebook/facebook_share.svg'
import write from './images/facebook/facebook_write.svg'
import play from './images/facebook/facebook_play.svg'
import DisplayCard from '~/Common-Objects/UI/DisplayCard'
import { LinkPreview } from '../shared'

export default function SocialFacebookPreview({
    account,
    startDate,
    content,
    images = [],
    foundLink = null,
    video = false
}) {
    const now = moment(startDate)
    return (
        <div style={{ width: 480, borderRadius: 8, backgroundColor: 'white', fontFamily: 'inter', lineHeight: '13px' }}>
            {/* header */}
            <div style={{ padding: '12px 16px', display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: 8 }}>
                    <img
                        style={{ height: 40, width: 40, borderRadius: '20px', alignSelf: 'stretch' }}
                        src={account.image}
                    />
                </div>
                <div style={{ flexGrow: 1 }}>
                    <div
                        style={{
                            fontSize: 14,
                            fontWeight: '600',
                            color: 'black',
                            letterSpacing: '0.20px',
                            marginBottom: 7
                        }}
                    >
                        {account.name}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            color: '#65676B',
                            fontWeight: '400',
                            fontSize: 13,
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}
                    >
                        {now.format('MMMM DD')} at {now.format('h:mm A')} <img style={{ marginLeft: 10 }} src={globe} />
                    </div>
                </div>
                <div style={{ marginLeft: 8 }}>
                    <img src={menu} />
                </div>
            </div>

            {/* content */}
            <div
                style={{
                    padding: '0 16px 16px 16px',
                    fontSize: '15px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    wordBreak: 'break-all'
                }}
                dangerouslySetInnerHTML={{ __html: content }}
            ></div>

            {/* link preview */}
            {!!foundLink && !images.length && (
                <div style={{ padding: '0 16px 16px 16px' }}>
                    <LinkPreview title={foundLink.title} image={foundLink.image} />
                </div>
            )}

            {/* images */}
            {images?.length === 1 && (
                <div style={{ position: 'relative' }}>
                    <img
                        src={images[0].url || images[0]}
                        style={{
                            backgroundColor: '#e0e0e0',
                            width: '100%',
                            position: 'relative',
                            justifyContent: 'center'
                        }}
                    />
                    {video && (
                        <div
                            style={{
                                position: 'absolute',
                                height: '100%',
                                width: '100%',
                                top: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <img src={play} />
                        </div>
                    )}
                </div>
            )}

            {images.length > 1 && images.length < 5 && (
                <div
                    style={{
                        display: 'flex',
                        padding: '0 0 16px 0',
                        position: 'relative',
                        height: 320,
                        width: 480,
                        gap: 2
                    }}
                >
                    {/* split the images, 1st on the left, rest on the right stacked, up to 3 then a plus indicating more */}
                    <div style={{ flexGrow: 1 }}>
                        <div
                            key={0}
                            style={{
                                backgroundSize: 'cover',
                                backgroundPositionX: 'center',
                                backgroundPositionY: 'center',
                                backgroundRepeat: 'no-repeat',
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                backgroundImage: `url(${images[0].url || images[0]})`
                            }}
                        ></div>
                    </div>
                    <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {images.slice(1).map((image, index) => {
                            if (index > 2) return null
                            return (
                                <div
                                    key={index}
                                    style={{
                                        backgroundSize: 'cover',
                                        backgroundPositionX: 'center',
                                        backgroundPositionY: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        backgroundImage: `url(${image.url || image})`
                                    }}
                                >
                                    {index === 2 && images.length > 4 && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                height: '100%',
                                                width: '100%',
                                                top: 0,
                                                backgroundColor: 'rgba(0,0,0,0.5)',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: 'white',
                                                fontSize: 32,
                                                fontWeight: '600'
                                            }}
                                        >
                                            +{images.length - 4}
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}

            {images.length >= 5 && (
                // two top row, 3 bottom row, with +[how many more] as an overlay on the last
                <div
                    style={{
                        display: 'flex',
                        padding: '0 0 16px 0',
                        position: 'relative',
                        height: 320,
                        width: 480,
                        gap: 2,
                        flexDirection: 'column'
                    }}
                >
                    <div style={{ display: 'flex', flexGrow: 1, gap: 2 }}>
                        {images.slice(0, 2).map((image, index) => (
                            <div
                                key={index}
                                style={{
                                    backgroundSize: 'cover',
                                    backgroundPositionX: 'center',
                                    backgroundPositionY: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    backgroundImage: `url(${image.url || image})`
                                }}
                            ></div>
                        ))}
                    </div>
                    <div style={{ display: 'flex', flexGrow: 1, gap: 2 }}>
                        {images.slice(2, 5).map((image, index) => (
                            <div
                                key={index}
                                style={{
                                    position: 'relative',
                                    backgroundSize: 'cover',
                                    backgroundPositionX: 'center',
                                    backgroundPositionY: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    backgroundImage: `url(${image.url || image})`
                                }}
                            >
                                {index === 2 && images.length >= 6 && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            height: '100%',
                                            width: '100%',
                                            top: 0,
                                            backgroundColor: 'rgba(0,0,0,0.5)',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            color: 'white',
                                            fontSize: 32,
                                            fontWeight: '600'
                                        }}
                                    >
                                        +{images.length - 5}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* footer */}
            <div style={{ padding: '0 16px' }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '4px 0',
                        borderBottom: '1px #CFD0D4 solid'
                    }}
                >
                    <img src={like} />
                    <img src={comment} />
                    <img src={share} />
                </div>
                <div style={{ padding: '8px 0', display: 'flex', alignItems: 'center' }}>
                    <img src={account.image} style={{ height: 32, width: 32, borderRadius: '20px', marginRight: 6 }} />
                    <img src={write} />
                </div>
            </div>
        </div>
    )
}
